import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'search-graph-data-table.data-table-label',
		defaultMessage: 'Data table',
		description: 'Data table subtype label',
	},
});
